const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const ScaredCondition = require('../../conditions/ScaredCondition');
const CCHandler = require('../../CCHandler');
const BattleConfig = require('../../../constants/BattleConfig');
const { logError } = require('../../logger');

const RoadToNowhere = function(battleState) {
  this.handle = 'road_to_nowhere';
  this.magic = true;
  this.harm = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = () => true;

  this.execute = function(actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit&&!victim.inPlay)) {
      return { success: false };
    }

    var ability = BattleCalc.getEquippedAbility(actor, this.handle);

    setTimeout(() => {
      try {
        if (!actor || !actor.inPlay || !victim || (victim.unit && !victim.inPlay)) {
          return;
        }

        var success = false;
        var scared = null;

        if (!CCHandler.checkForResistFear(victim,battleState)) {
          scared = new ScaredCondition(actor, victim, battleState, ability.duration);
          scared.instigatorId = actor.uid;
          scared.ownerId = victim.uid;
          battleState.onUnitCondition(scared);
          success = true;
        }

        var result = { success,scared };
        result.abilityHandle = this.handle;
        result.actorId = actor.uid;
        result.victimId = victim.uid;
        result.allPieces = battleState.allPieces;

        this.eventEmitter.emit('result', result);
      } catch (err) {
        logError(err, {
          module: 'RoadToNowhere',
          func: 'execute',
          actor,
          victim,
        });
      }
    }, BattleCalc.projectileTime(BattleConfig.THROWN_SPEED, actor, victim));
  };
};
module.exports = RoadToNowhere;
